// Data preparation for search results rendering

/**
 * Extract link and name keys from results
 * @param {Array} results - Search results array
 * @returns {Object} Link keys and name keys arrays
 */
export function extractKeys(results) {
    const linkKeys = [];
    const nameKeys = [];
    
    results.forEach((item) => {
        const linkKey = (item.link || item.path || '').replace(/^\/+/, '');
        const nameKey = (item.name || linkKey.split('/').pop() || '').toString();
        linkKeys.push(linkKey);
        nameKeys.push(nameKey);
    });
    
    return { linkKeys, nameKeys };
}

/**
 * Check which files have summaries in cache
 * @param {Array} linkKeys - Link keys array
 * @param {Array} nameKeys - Name keys array
 * @returns {Set} Set of keys that have summaries
 */
export async function checkSummariesAvailability(linkKeys, nameKeys) {
    const hasSummaries = new Set();
    
    try {
        if (window.filesCacheManager && typeof window.filesCacheManager.getSummariesByKeys === 'function') {
            const summariesByLink = await window.filesCacheManager.getSummariesByKeys(linkKeys);
            summariesByLink.forEach((summary, idx) => { 
                if (summary) hasSummaries.add(linkKeys[idx]); 
            });
            
            const summariesByName = await window.filesCacheManager.getSummariesByKeys(nameKeys);
            summariesByName.forEach((summary, idx) => { 
                if (summary) hasSummaries.add(nameKeys[idx]); 
            });
        }
    } catch(_) {}
    
    return hasSummaries;
}

/**
 * Prepare results data for rendering
 * @param {Object} data - Search results data
 * @returns {Object} Prepared data with results, pagination, and keys
 */
export async function prepareResultsData(data) {
    const results = (data && data.results) || [];
    const total = (data && data.pagination && typeof data.pagination.total_results === 'number') 
        ? data.pagination.total_results 
        : results.length;
    
    const currentPage = (data && data.pagination && Number(data.pagination.current_page)) || 1;
    const itemsPerPage = (data && data.pagination && Number(data.pagination.items_per_page)) || 10;
    
    const { linkKeys, nameKeys } = extractKeys(results);
    const hasSummaries = await checkSummariesAvailability(linkKeys, nameKeys);
    
    return {
        results,
        total,
        currentPage,
        itemsPerPage,
        linkKeys,
        nameKeys,
        hasSummaries
    };
}

